import { brandBgDataHeight } from "./brand-bg-data-height";
import { brandBgDataUrl } from "./brand-bg-data-url";
import { brandBgDataWidth } from "./brand-bg-data-width";
import { brandBgEntityId } from "./brand-bg-entity-id";
import { brandBgIsDefault } from "./brand-bg-is-default";
import { brandBgIsInUse } from "./brand-bg-is-in-use";
import { brandBgSid } from "./brand-bg-sid";
import { brandEntityId } from "./brand-entity-id";

export const brandBgEntityRaw = {
  type: "object",
  required: [
    "id",
    "sid",
    "dataUrl",
    "width",
    "height",
    "isDefault",
    "isInUse",
    "brandId"
  ],
  properties: {
    id: brandBgEntityId,
    sid: brandBgSid,
    dataUrl: brandBgDataUrl,
    width: brandBgDataWidth,
    height: brandBgDataHeight,
    isDefault: brandBgIsDefault,
    isInUse: brandBgIsInUse,
    brandId: brandEntityId
  },
  additionalProperties: false
};
